import styled from "styled-components";
import { GlassmorphismContainer } from "../shared/Glassmorphism";

export const PathButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;

    font-size: 15px;
    background-color: rgba(255, 255, 255, 0.16);
    color: rgba(255, 255, 255, 0.56);
    border: 1px solid rgba(255, 255, 255, 0.56);
    padding: 10px 20px;
    border-radius: 8px;
    cursor: pointer;
    width: 100%;
    height: 40px;
    box-sizing: border-box;
    transition: all 0.2s ease;
    &:hover {
      background-color: #00ff99;
      color: #000;
    }
    &.active {
      border: 1px solid #00ff99;
      background-color: rgba(0, 255, 153, 0.1);
      color: #00ff99;
    }
  }
`;

export const InnerScrollContainer = styled.div`
  overflow: auto;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  scrollbar-width: none;
`;

export const ToggleButtonContainer = styled.div`
  display: flex;

  margin-bottom: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.24);

  button {
    white-space: nowrap;
    background-color: transparent;
    border: none;
    cursor: pointer;
    flex-grow: 1;
    color: rgba(255, 255, 255, 0.56);

    padding: 14px 0;
    font-size: 14px;
    font-weight: 500;

    &.active {
      color: #00ff99;
      border-bottom: 2px solid #00ff99;
    }
  }
`;

export const PotreeControlContainer = styled(GlassmorphismContainer)`
  /* overflow: auto; */
  transition-duration: 500ms;
  z-index: 1000;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 20px;
  width: 370px;
  height: 80%;
  /* padding: 20px; */
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  h2 {
    color: #fff;
    font-size: 14px;
  }

  /* scrollbar-width: none; */
  &.hidden {
    /* right: -370px; */
    right: 0;
    transform: translateY(-50%) translateX(100%);
  }

  @media (max-width: 600px) {
    top: auto;
    bottom: 0;
    left: 50%;
    transform: translateY(0%) translateX(-50%);
    width: 98%;
    max-width: 370px;

    &.hidden {
      transform: translateY(80%) translateX(-50%);
    }
  }
`;

export const ControlDockHeader = styled.header`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;

  h2 {
    font-size: 20px;
    font-weight: 600;
  }

  p {
    font-size: 14px;
    font-weight: 400;
    color: #cecece;
  }
`;

export const ControlDockContent = styled.section`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  gap: 10px;

  .ControlDockContentDivider {
    width: 100%;
    height: 2px;
    background-color: rgb(216 216 216 / 24%);
    border: none;
    margin: 20px 0;
  }
`;

export const PointButtonContainer = styled.section`
  display: flex;
  border-bottom: 2px solid rgba(255, 255, 255, 0.24);
  position: relative;

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 1px;
    background-color: rgba(255, 255, 255, 0.24);
    height: 100%;
  }
`;

export const PointButton = styled.button`
  background-color: transparent;
  border: none;
  color: #fff;
  width: 50%;
  height: 100px;
  padding: 10px;
  box-sizing: border-box;
  text-align: left;
  background-image: url("/Icons/plus-lg.svg");
  background-repeat: no-repeat;
  background-position: top 10px right 10px;
  background-size: 20px;
  cursor: pointer;

  .StartPoint {
    background-image: url("/Icons/geo-alt.svg");
    background-repeat: no-repeat;
    background-position: left 5px center;
  }

  .EndPoint {
    background-image: url("/Icons/flag.svg");
    background-repeat: no-repeat;
    background-position: left 5px center;
  }

  h3 {
    font-size: 14px;
    padding: 5px 0 5px 25px;
  }

  p {
    color: #c2c2c2;
    font-size: 12px;
    padding-left: 5px;
    white-space: pre-line; /* \n을 줄바꿈으로 처리 */
  }
`;

export const WorkTypeContainer = styled.section`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  header {
    display: flex;
    align-items: center;

    button {
      background-color: transparent;
      border: none;
      color: #fff;
      width: 14px;
      cursor: pointer;
    }
  }

  .WorkTypeButtonContainer {
    display: flex;
    gap: 10px;
  }
`;

export const WorkTypeButton = styled.button`
  background-color: rgba(44, 44, 44, 0.7);
  color: rgba(255, 255, 255, 0.24);
  width: 100%;
  /* max-width: 100px; */
  /* height: 100px; */
  padding: 17px 0;
  box-sizing: border-box;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.24);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
  cursor: pointer;

  &.selected {
    color: #00ff99;
    border: 1px solid #00ff99;
  }
`;

export const EquipmentContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 10px;

  select {
    background-color: rgba(33, 33, 33, 0.81);
    border: solid 1px rgba(211, 211, 211, 0.42);
    color: #fff;
    font-size: 15px;
    padding: 14px 17px;
    border-radius: 10px;
    cursor: pointer;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;

    background-image: url("/Icons/chevron-down.svg");
    background-repeat: no-repeat;
    background-position: right 17px center;
    background-size: 20px;

    option {
      background-color: rgba(33, 33, 33, 0.81);
      color: #fff;
      font-size: 15px;
      padding: 14px 17px;
    }
  }
`;

export const AreaGenerateContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 10px;
  width: 100%;

  .AreaGenerateSelectContainer {
    display: flex;
    gap: 10px;
    width: 100%;

    select {
      flex-grow: 1;
    }
    .AreaGenerateSelectButton {
      width: 40px;
      height: 40px;
      background-color: rgba(0, 255, 153, 0.1);
      color: #fff;
      border: 1px solid #00ff99;
      border-radius: 4px;
      cursor: pointer;
    }
  }
`;

export const ObstacleContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 20px;

  .ObstacleWrapper {
    display: flex;
    flex-direction: column;
    gap: 10px;
    overflow-y: auto;
  }

  .ObstacleAddButton {
    flex-shrink: 0;
    height: 100px;
    background-color: rgba(33, 33, 33, 0.81);
    color: rgba(255, 255, 255, 0.56);
    border: 1px solid rgba(255, 255, 255, 0.24);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    cursor: pointer;
    border-radius: 8px;

    svg {
      width: 24px;
      height: 24px;
    }
  }
`;

export const AreaIcon = styled.svg`
  width: 24px;
  height: 24px;
  color: ${({ $color }) => ($color ? $color : "#fff")};
`;

export const ObstacleItem = styled.div`
  background-color: rgba(33, 33, 33, 0.81);
  border-radius: 8px;
  color: #fff;
  display: flex;
  flex-direction: column;
  gap: 10px;

  padding: 15px;
  box-sizing: border-box;
  border: 1px solid rgba(255, 255, 255, 0.24);
  cursor: pointer;
  position: relative;

  .ObstacleItemHeader {
    display: flex;
    align-items: flex-end;
    gap: 5px;
    height: 23px;
    /* background-image: url("/Icons/cone-striped.svg");
    background-repeat: no-repeat;
    background-position: left center;
    background-size: 23px;
    padding-left: 27px; */
    box-sizing: border-box;

    .ObstacleItemIndex {
      color: rgba(255, 255, 255, 0.53);
      font-size: 12px;
    }

    .ObstacleItemType {
      font-size: 15px;
      font-weight: 400;
      color: #fff;
    }
  }

  .ObstacleItemContent {
    font-size: 15px;
    display: flex;
    flex-direction: column;
    gap: 5px;
    align-items: flex-start;
    p {
      margin-bottom: 5px;
      font-size: 14px;
    }
    small {
      font-size: 12px;
      color: rgba(255, 255, 255, 0.53);
    }
  }

  .ObstacleDeleteButton {
    position: absolute;
    top: 10px;
    right: 10px;
    background-color: transparent;
    border: none;
    cursor: pointer;
    color: #ff6b6b;
    font-size: 12px;
    font-weight: 500;
    padding: 0;
    margin: 0;
    background: none;
    border: none;
    cursor: pointer;

    svg {
      width: 16px;
    }
  }
`;

export const SubmitButton = styled.button`
  background-color: ${({ $switchState }) =>
    $switchState ? "rgba(255, 0, 0, 0.1)" : "rgba(0, 255, 153, 0.1)"};
  color: ${({ $switchState }) => ($switchState ? "#ff0066" : "#00ff99")};
  border: 1px solid
    ${({ $switchState }) => ($switchState ? "#ff0066" : "#00ff99")};
  width: 100%;
  height: 60px;
  border-radius: 12px;
  margin-top: 20px;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background-color: ${({ $switchState }) =>
      $switchState ? "#ff0066" : "#00ff99"};
    color: #000;
  }

  &:disabled {
    background-color: rgba(255, 255, 255, 0.05);
    color: rgba(255, 255, 255, 0.3);
    border: 1px solid rgba(255, 255, 255, 0.2);
    cursor: not-allowed;

    &:hover {
      background-color: rgba(255, 255, 255, 0.05);
      color: rgba(255, 255, 255, 0.3);
    }
  }
`;

export const AreaGenContainer = styled.div`
  .AreaGenerateContainer {
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
    padding-bottom: 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.24);
  }

  .AreaSelectContainer {
    margin-top: 20px;
  }

  .WorkTypeButtonContainer {
    display: flex;
    gap: 10px;
    width: 100%;
    justify-content: center;
  }

  .AreaGenerateButtonContainer {
    display: flex;
    gap: 10px;
    width: 100%;
    justify-content: center;
  }

  .AreaForm {
    width: 100%;
    background-color: rgba(33, 33, 33, 0.81);
    border: 1px solid rgba(211, 211, 211, 0.42);
    color: #fff;
    font-size: 15px;
    padding: 14px 17px;
    border-radius: 10px;
    box-sizing: border-box;
  }
  .AreaFormContainer {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
  }
  .AreaInputLabel {
    font-size: 15px;
    font-weight: 400;
    color: #fff;
  }
  .AreaSelectItem {
    background-color: rgba(44, 44, 44, 0.7);
    padding: 20px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    position: relative;
    cursor: pointer;
  }
  .AreaSelectItemDownloadButton {
    background-color: rgba(0, 255, 153, 0.1);
    border: 1px solid #00ff99;
    cursor: pointer;
    color: #00ff99;
    font-size: 12px;
    border-radius: 8px;
    padding: 5px 10px;
    display: flex;
    align-items: center;
    gap: 5px;
  }
  .AreaSelectItemIcon {
    position: absolute;
    bottom: 15px;
    right: 15px;
    color: #fff;
    display: flex;
    gap: 10px;
    align-items: center;
  }
  .AreaSelectItemTitle {
    font-size: 16px;
    font-weight: 500;
    color: #fff;

    position: relative;
    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: -6px;
      display: block;
      width: 3px;
      height: 100%;
      background-color: #00ff99;
    }
  }
  .AreaSelectItemDescription {
    font-size: 13px;
    color: #bebebe;
    font-weight: 400;
    display: flex;
    justify-content: space-between;
    span {
      font-size: 14px;
      color: #fff;
    }
  }

  .AreaSelectItemDescription.selected {
    display: block;
    span {
      font-size: 15px;
      color: #00ff99;
    }
  }
  .AreaSelectItemDistance {
    font-size: 15px;
    color: #fff;
    font-weight: 400;

    span {
      font-size: 30px;
      font-weight: 700;
      color: rgb(255, 255, 255);
      white-space: nowrap;
      display: inline-block;
      width: 45%;

      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .AreaSelectItemDeleteButton {
    background-color: transparent;
    border: none;
    position: absolute;
    top: 10px;
    right: 10px;
    color: #fff;
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
  }

  .AreaSelectList {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
`;

export const AreaSubmitButton = styled(SubmitButton)`
  margin-top: 20px;
`;

export const AutovehicleSpecsInputContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  width: 100%;
  padding: 10px;
  color: #fff;
  font-size: 14px;

  div {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
  span {
    white-space: nowrap;
    font-size: 12px;
    color: rgb(191, 191, 191);
    line-height: 1.5;
  }

  input {
    -moz-appearance: textfield;
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    width: 60%;
    background-color: rgb(41 41 41 / 81%);
    color: #fff;
    border: none;
    border-radius: 5px;
    padding: 10px;

    &::placeholder {
      color: rgb(216, 216, 216);
    }
  }
`;

export const WorkingModeContainer = styled.div`
  .ControlDockContentText {
    font-size: 16px;
    line-height: 1.5;
    color: #fff;
    font-weight: 400;
    text-align: center;
  }
`;
